module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Daisies Are Forever")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#cnt16",
      "id": "ctn16"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "txline"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("T")]), _vm._v("he weight of exhaustion bore down on Gisela’s shoulders. Her legs burned from the effort of pedaling the bicycle while her toes burned with the cold. Her eyes refused her command to stay open, her eyelids fluttering like flags in the breeze. Annelies and Renate had cried themselves to sleep around dawn. At first Gisela had been glad for the quiet, but now their screaming would help keep her awake and alert.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann pedaled behind her, his handcart trailing him. Each time she glanced back, he had fallen a little farther behind. Bettina and Katya trudged alongside. The older of the two sisters, Bettina, drew her blue wool coat around her bony frame. Even with the distance between them, Gisela caught Bettina’s remarks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Brother, why are we out strolling at this time of night? This is not sensible. I have never heard the likes of such things, have you, Sister?” Her words whistled between the gap in her front teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann sighed. He must grow weary of the bizarre questions his senile sisters barraged him with.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All throughout the night, Gisela’s thoughts returned to the "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("little house in Heiligenbeil. What must be happening to Ella? She glanced at the children asleep in the cart. Both of them had inherited their mother’s button nose, and both had their mother’s freckles spattered across their faces.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("With half-frozen fingers, Gisela gripped the bicycle’s handlebars tighter. How would she explain their mother’s choices to the children? They had lost so much already.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And what about Opa? Every time she thought about him, her throat ached. He was an old man. Would the Soviets take pity on him?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nein. She knew the answer. She bit back her tears.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She slowed her pedaling and rode to the side of the congested street to allow Herr Holtzmann to catch up to her. Wagons, carts, and people so clogged the road that he almost drove past. She waved and he pushed his way toward them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She dismounted. “Your cart is too heavy for you. Let me see what I can take and what we might be able to leave.” She rummaged through his belongings, pulling a few cast-iron pots and pans from in between the bedding and setting them alongside the road.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Katya unloaded a box spilling over with picture albums and books and transferred it to Gisela’s cart. Bettina joined in, grabbing a load of stuff in her scrawny arms and plopping it on Annelies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann hurried to pull the pile from on top of the giggling girl. “Sisters, that is enough. We can’t let Gisela carry all of our belongings.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Still digging in the Holtzmanns’ quilts, Gisela pulled out a mantel clock, painted blue with yellow flowers scrolled across the case. She held it high. “Do you need this?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He swallowed hard and pulled his cap farther over his balding head. “Ursula loved that clock. It has been in her family for a long time.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Gisela tried to ignore the wistfulness in the man’s voice. It was ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("impractical. Better they leave his late wife’s clock than the pots. You couldn’t warm food in a timepiece. His pleading blue eyes begged her not to dispose of this treasure. Then she thought of her Bible and her treasure tucked in its pages. Never would she want to leave it. She placed the clock among the blankets and pillows once more.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann kissed her cheek with his chapped lips. “"), _c('i', [_vm._v("Danke")]), _vm._v(". You understand. It is all I have left of her. Sixty years and that is all that remains.” His eyes watered with unshed tears. Gisela turned away, not wanting to give way to her own grief.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A moment later, he touched her shoulder. “It is nearly noon. My friend and his wife own a farm along this road. Let’s find him and see if he has a place for us to rest and a room for us to spend the night. You look like you need a decent sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dark circles rimmed his eyes. She imagined she looked much the same. “You too. But are we far enough ahead of the Soviets? What if they catch up to us?” What if they were overtaken while they slept? Gisela’s stomach flipped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the cart Renate stirred. She scanned her surroundings, her eyes large. Tears gathered and threatened to spill. “Where is Mutti? I want Mutti to come.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Annelies squared her shoulders. Gisela sensed she fought the urge to break into tears herself. Gisela longed for her own mutti as much as Renate wanted hers. Family. Most of these people were going anywhere as long as it was west. She needed to get to Berlin, to take care of her mutti. From there they could travel to Munich. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Renate continued to cry for her mother. How could Ella have abandoned them? At least when Gisela’s parents sent her east, she was an adult.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("She pulled the girls from the cart and gathered them close. “Your mutti will be along very, very soon. She had to finish some work and take care of Opa, and then she is going to join us. Remember, we are ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("having a great adventure. We will make new friends and see new things. You have to be big girls.” They didn’t understand their loss.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Annelies blinked away her tears. “I can be a big girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Me too. I be a big girl.” Renate refused to let her sister get the last word.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Very good. I’m proud of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tante Gisela, would you sing the wagon song for us again?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ja, wagon song.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You walk and follow Herr Holtzmann, and we can sing the song.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann mounted his bicycle and the group rolled down the streets of the sleepy village, the girls in all their clothing waddling along like two penguins."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('i', [_vm._v("High on the yellow coach ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('i', [_vm._v("I sit in front with the coachman.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('i', [_vm._v("The white horses start trotting, ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('i', [_vm._v("Merrily peals the horn.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('i', [_vm._v("Meadows, pastures, and marshes, ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('i', [_vm._v("Ripening grain shimmering gold.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('i', [_vm._v("How I would like to stay, ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_c('i', [_vm._v("But the coach rolls on.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The group sang the refrain several times—the Holtzmann sisters the loudest—before they arrived at a squat stone farmhouse, brightly lit windows staring at them. A huge barn overshadowed the cheery, inviting home, the once-vivid green exterior in need of a new coat of paint.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An older woman met them at the entrance when they knocked. Her mouth dropped into an "), _c('i', [_vm._v("O")]), _vm._v(". “Oy, Dietrich, is it good to see you and your sisters. And this.” She scanned the bedraggled band and a smile curved her lips. “Who is this you have brought us?”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“Let me introduce Gisela Cramer and her cousin’s children, Renate and Annelies Reinhardt. Ladies, this is "), _c('i', [_vm._v("Frau")]), _vm._v(" Becker.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Annelies went to shake the woman’s hand, polite as her mother had taught her. Instead, the woman, a heavy crown of braids ringing her head, pulled the child into a grandmotherly hug. “Little girls. So long it has been since we had little girls.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Renate flung herself into the old woman’s embrace. “Me too.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Frau Becker laughed. “Of course. We should not forget you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the millionth time that day, Gisela’s heart tugged with thoughts of her grandfather. He loved the girls so much. They should have had more years together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("God, please take care of him.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Frau Becker ushered the group into the house, already overflowing with refugees. Bedding covered the parlor floor and the couches and chairs. Farther into the home, women jostled for position at the stove. Frau Becker patted her hand. “You see, we don’t have much room. What we have, though, you are welcome to.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The noise and heat and confusion started a pounding behind Gisela’s left eye. “That is very kind of you.” If they stayed here, they would have to sleep standing up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann cleared his throat. “Your husband, is he around?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All at once, the joy left the older woman’s eyes. “Heinz had a stroke this fall. He cannot move his left side, and his speech isn’t so good anymore. That is why we stay. We cannot leave with him like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herr Holtzmann nodded and rubbed the spot between his nose and lips. “I would like to see him.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Their hostess pushed her way through the crowd and down the hall to the last of two doors on the left. “You visit with him for a while. We have some room in the attic. There is no heat, but you are welcome to stay there. Or the barn, but I fear those conditions ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("are worse. That is all I have. Come, girls, let me help you settle.” Herr Holtzmann slipped inside and shut the door.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Frau Becker never stayed still, her hands moving even when the rest of her body didn’t, and she reached the top attic step before Gisela had willed herself to reach the third. When Gisela was a child, Mutti had always wished for a tenth of Gisela’s energy. She now understood the feeling. She had to drag her feet up the flight of stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sloped roof, its rafters exposed, covered the large space. Even here, though, there would be no privacy. Groups had spread blankets and duvets over almost every square inch of the room. Gisela stared at one woman, her round face unlined though gray streaked her dark hair. The strands hung loose and dirty around her face. She held a screaming infant and patted the child’s bottom. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The stench of unwashed bodies pressed in on Gisela. She squeezed the girls’ hands. She had imagined conditions to be poor, but not like this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Frau Becker shook her head. “These people keep coming and coming, and they don’t stop. More and more every day. You don’t want to sleep in the barn. I wonder, where will this crowd go? Is there food for so many in the west?”")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("After they had hidden in the underbrush for a while, Mitch and Xavier continued to run across snow-covered fields, tripping and stumbling along until the world spun in front of Mitch’s eyes. When his legs cramped so he couldn’t take another step, they sought shelter on the dark side of a barn. This farm stood off the main road.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Over their panting, Mitch listened for any sound of approaching German soldiers. He strained his ears for the slightest giveaway—a footstep, a cough, a whisper. The night remained still. He put his hands on his knees and took several deep breaths. ")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Xavier slapped him on the back. “Away by the skin of our teeth, mate. That was grand fun.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Mitch raised his eyebrows. “Grand fun? You’ve gone crackers. Let’s not do that ever again. We have to be more careful from here on out. Follow the crowds but at more of a distance.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Trouble is, we’ve left our dixies and pans and Spam at that farmhouse. Not to mention our last couple of matches.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was an awful blow, but what could they do? There was no way Mitch was stepping foot back on that property. “We’ll have to improvise.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I improvise that we go back and retrieve our supplies.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Now I know you’re crackers, Xavier. That woman would turn us in without blinking an eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Listen, I have a brilliant idea. We’ll slink in and grab our supplies and out we go. In an hour or two, everyone will be sleeping and no one will know we’ve been there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And that’s your brilliant idea?” Over the years, Mitch had to talk Xavier out of more brilliant ideas than he could dare count. And there were plenty he hadn’t talked him out of. His dad disapproved of Mitch palling around with Xavier, afraid he would get a criminal record and ruin his chances at becoming a solicitor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And yours is what?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Getting some sleep.” Mitch pushed open the big barn door just enough to slip inside. Xavier, thankfully, followed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You can get all the sleep you want. I’m going back. Without those supplies, we’re sunk lower than a U-boat.” Xavier stomped out. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After all these years, he knew how to get under Mitch’s skin. “Xavier, listen to reason. Is a nearly empty can of Spam and two old tin cups worth a shot through the heart? Not to me. Not by a long sight. We can eat snow and raw potatoes.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("But Xavier didn’t listen. In the glow of the snow, Mitch watched him march off. Did he dare shout after him and risk waking the ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("farmer’s family? Mitch stomped after his friend. You’d think so many years in a POW camp would have taught Xavier some common sense.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Mitch caught up and marched alongside Xavier, not saying a word. At least this time they wouldn’t end up walking around in circles, their footprints from earlier their guidepost.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The cold night air bit through his coat and his worn gloves. Mitch had no feeling left in his toes and doubted he ever would again. Each step brought excruciating pain to his legs. “Is this worth a can of that rubbish they call meat? You do realize that one refugee or another will have gobbled it up by now. If not handed it over to the Germans as proof we were there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“We’re this far. Let’s keep going. There’s no harm in looking, is there?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They walked and walked, never getting to that farm. Where could it have gone? It was impossible for them to go wrong this time. They had run far and long and fast, but even so, they should have come upon it by now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lost in the whiteness that was East Prussia.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Survived five years to die like this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Xavier was right. He was a cheery chap tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He wanted to lie down in the snow and go to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Xavier marched alongside him. “Keep awake, mate. Don’t let hypothermia get the best of you. We’re almost there. I have the feeling we’ve been here before.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Am I supposed to laugh at that?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I mean it. Is that it?” Xavier pointed at a light on the horizon. “Fires in the farmyard, perhaps?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mitch couldn’t be sure. “Let’s head in that direction. The worst it could be is our friends from the stalag.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Xavier clapped him on the back. “That’s the spirit. I like your optimism.”")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Just when Mitch believed he couldn’t put one foot in front of the other yet again, they made out the small house and the large barn. A farmyard. The layout matched with the one in his memory. As the first rays of sunlight pinked the sky, they arrived full circle at the place they had fled.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("They slunk into the still-quiet yard. A few unlucky ones slept out of doors, wrapped in layers of blankets near their fires. Together they searched the area without success. Mitch shot Xavier an I-told-you-so glance. He had the gall to shrug.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Motioning that it was time to get out of here, Mitch turned to leave. As he did so, he bumped into someone. Not just anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The scrawny, greasy-haired woman from the night before.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She stared at him. He peered at the point where her gaze bore into him. His lapel. The Nazi SS uniform that he and Xavier had stolen before their escape. Why was she so intent on what he wore? He crossed his arms to keep them from shaking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The woman stood, jiggling her wailing infant on her hip. He turned away from her, pretending he was looking for something.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A way out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He nudged Xavier and tipped his head in the woman’s direction. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The woman stepped in front of him. "), _c('i', [_vm._v("“Guten morgen.”")]), _vm._v(" Her breath stank of rotting teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His mouth went dry. “Guten morgen.” Why didn’t she leave him alone?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What unit did you serve with?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mitch pointed to the stylized SS on the lapel of his dark coat, hoping his shaking fingers wouldn’t give him away. “Stalag guard.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She tucked one dirty strand of hair behind her ear and leaned over him. “Then why aren’t you with the prisoners?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Separated from our unit. I told you so last night.” Xavier stood tall.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("She tilted her head and squinted her lifeless blue eyes. Then she spat at their feet. “You are no SS guards.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("“We are.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nein. Listen to you talk. You are either American or British.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“German,” Mitch growled at her. If she found out the truth . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You killed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I killed no one.” The unfortunate truth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She lunged at him. “My husband was in France, you dog, on the beach. The British killed him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("War slapped him in the face. His legs quivered. She would turn him in to the authorities who, busy driving westward, had little time to deal with escaped prisoners. They shot the escapees before they could defend themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Go away.” He ground his teeth to keep them from chattering. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You killed him.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606f3edf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter6.vue
// module id = 87
// module chunks = 0